/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum SettingCategory {
    Uncategorized = 0,
    AudioServer = 1,
    RecordingServer = 2,
    Smtp = 3,
    Zabbix = 4,
    Gamepad = 5,
    Event = 6,
    SimPortal = 7,
    UpdateServer = 8,
    Environment = 9,
    AutomaticRecording = 10,
}
